import { DateBox, Button as DateBoxButton } from "devextreme-react/date-box";
import { useEffectOnce } from "react-use";
import { DateHelper } from "../utils/DateHelper";

const DateEdit = ({ value = DateHelper.getDate(), setValue }) => {
  const todayButton = {
    text: "Today",
    onClick: () => {
      setValue(DateHelper.getDate());
    },
  };

  useEffectOnce(() => {
    setValue(value);
  });

  return (
    <DateBox
      value={value}
      stylingMode="outlined"
      showClearButton={true}
      useMaskBehavior={true}
      displayFormat=" dd MMM, yyyy"
      onValueChanged={(e) => setValue(e.value)}
    >
      <DateBoxButton name="today" location="before" options={todayButton} />

      <DateBoxButton name="dropDown" />
    </DateBox>
  );
};

export default DateEdit;
